<!-- THREE CONTROLS ON TWO ROWS (carbon `.itp-chat-panel__tools`): the search on a row of its own, then the grouping and,
     while presence is on (B-15), the status filter, half each. -->
<div class="chat-tools">
  <div class="chat-search-field">
    <i class="fa-regular fa-magnifying-glass" aria-hidden="true"></i>
    <input type="search" [value]="search" (input)="onSearch($any($event.target).value)"
           placeholder="Search by name or email" aria-label="Search members">
  </div>
  <div class="chat-tools__row">
    <mat-select class="chat-select" [value]="grouping" (selectionChange)="onGrouping($event.value)" aria-label="Group members">
      <mat-option *ngFor="let option of groupings" [value]="option.value">{{ option.label }}</mat-option>
    </mat-select>
    <mat-select *ngIf="showPresence" class="chat-select" [value]="status" (selectionChange)="onStatus($event.value)"
                aria-label="Filter members by status">
      <mat-select-trigger>{{ statusLabel }}</mat-select-trigger>
      <mat-option *ngFor="let option of statusFilters" [value]="option.value">
        <!-- The count rides in the menu row only (carbon); the option panel is an overlay, so its one style is inline. -->
        {{ option.label }}<span style="margin-left: 8px; opacity: .6; font-variant-numeric: tabular-nums">{{ statusCounts[option.value] }}</span>
      </mat-option>
    </mat-select>
  </div>
</div>

<!-- ONE SCROLLER FOR THE WHOLE TAB: XatBot's block, every heading and every group inside it, the headings sticky. -->
<div class="chat-scroll" [class.chat-scroll--clear]="clearForDisc">
  <ng-container *ngFor="let group of groups; trackBy: trackByGroup">
    <div class="chat-section" *ngIf="group.label !== null">
      <span class="chat-section__label">{{ group.label }}</span>
      <span class="chat-section__count">{{ group.people.length }}</span>
    </div>
    <ul class="chat-list">
      <li class="chat-list__item" *ngFor="let member of group.people; trackBy: trackByEmail">
        <button type="button" class="chat-row" (click)="open(member)"
                [attr.aria-label]="member.isXatBot ? 'Open XatBot' : 'Chat with ' + member.name">
          <span class="chat-row__face" aria-hidden="true">
            <messenger-presence-face [status]="statusOf(member)" [size]="44">
              <span *ngIf="member.isXatBot; else personFace" class="chat-ai-face">
                <ai-tax-icon [size]="28" idSuffix="chat-members"></ai-tax-icon>
              </span>
              <ng-template #personFace>
                <ngx-stored-gravatar [email]="member.email" [name]="member.name" [style]="faceStyle"></ngx-stored-gravatar>
              </ng-template>
            </messenger-presence-face>
          </span>
          <span class="chat-row__text">
            <span class="chat-row__line">
              <span class="chat-row__name">{{ member.name }}</span>
              <span class="chat-row__role" *ngIf="roleOf(member) as role">{{ role }}</span>
            </span>
            <span class="chat-row__line">
              <span class="chat-row__last">{{ member.detail }}</span>
            </span>
          </span>
        </button>
      </li>
    </ul>
  </ng-container>

  <div class="chat-empty" *ngIf="state === 'loading'" role="status">
    <mat-spinner diameter="24" aria-label="Loading members"></mat-spinner>
  </div>
  <div class="chat-empty" *ngIf="state === 'error'" role="alert">
    <span>Couldn't load members.</span>
    <button mat-stroked-button type="button" (click)="load()">Retry</button>
  </div>
</div>
